// The application is one form split into steps. Each step lists the fields it
// validates before moving on; the questions step exists only when the role
// has screening questions.

export const RESIDENCY = [
  { value: "uae citizen", label: "UAE national" },
  { value: "resident", label: "Resident visa" },
  { value: "dependent", label: "Dependent visa" },
  { value: "visit", label: "Visit visa" },
];

export const GENDER = [
  { value: "male", label: "Male" },
  { value: "female", label: "Female" },
];

export const COVER_LETTER_MAX = 2000;

export const EMPTY_VALUES = {
  first_name: "",
  last_name: "",
  email: "",
  phone: { country: "AE", number: "" },
  nationality: "",
  residence_status: "",
  gender: "",
  resume: "",
  resume_name: "",
  cover_letter: "",
  answers: {},
};

const ALL_STEPS = [
  {
    id: "contact",
    short: "Contact details",
    title: "Your contact details",
    intro: "So our team can reach you about this role.",
    fields: ["first_name", "last_name", "email", "phone"],
  },
  {
    id: "about",
    short: "About you",
    title: "A bit about you",
    intro: "This helps us understand your visa and work situation.",
    fields: ["nationality", "residence_status", "gender"],
  },
  {
    id: "cv",
    short: "CV",
    title: "Your CV",
    intro: "Add your latest CV. A short note is optional.",
    fields: ["resume", "cover_letter"],
  },
  {
    id: "questions",
    short: "Questions",
    title: "A few quick questions",
    intro: "A few things the team needs to know for this role. There are no trick questions.",
    fields: [],
  },
  {
    id: "review",
    short: "Review and send",
    title: "Check and send",
    intro: "Make sure everything looks right, then send your application.",
    fields: [],
  },
];

export const stepsFor = (hasQuestions) =>
  ALL_STEPS.filter((step) => hasQuestions || step.id !== "questions");

export const normaliseEmail = (email) => String(email || "").trim().toLowerCase();

export const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
